import { sleep } from '../../../util';
import { isObject } from '../../../util/guards';
import { emitter } from '../../util/emitter';
import { logger } from '../../util/logger';
import { STATUS } from '../httpClient';
import { THandler } from './types';

const BOT_TYPING_DELAY = 1000;

export const handleConflictStatus: THandler = (res) => {
  if (res.status === STATUS.CONFLICT || res.data?.sessionOutdated) {
    emitter.emit('reloadChat', undefined);
  }

  return res;
};

export const addToQueue: THandler = (res) => {
  emitter.emit('chatbotStateChanged', res.data);

  return res;
};

export const debug: THandler = (res) => {
  if (isObject(res.data)) {
    logger.debug(res.data.debug);
  }

  return res;
};

export const threeDotsDelay = async (requestStartedTs: number) => {
  const requestEndedTs = Date.now();
  const diff = requestEndedTs - requestStartedTs;
  if (diff < BOT_TYPING_DELAY) {
    await sleep(BOT_TYPING_DELAY - diff);
  }
};
